module.exports = __webpack_public_path__ + "img/gwc.a948db3e.png";